import { S25Util } from "../../util/s25-util";
import { SheetEntry, Stox, WorkBook, XLSX } from "./types/sheet.js.types";

export class SpreadSheetService {
    static scriptsPromise: Promise<void> = null;

    public static load() {
        SpreadSheetService.scriptsPromise =
            SpreadSheetService.scriptsPromise ||
            S25Util.all([]).then(async () => {
                await S25Util.loadScript(
                    "xlsx-spreadsheet-css",
                    "https://unpkg.com/x-data-spreadsheet@1.1.9/dist/xspreadsheet.css",
                );
                await S25Util.loadScript(
                    "xlsx-spreadsheet-js",
                    "https://unpkg.com/x-data-spreadsheet@1.1.9/dist/xspreadsheet.js",
                );
                await S25Util.loadScript(
                    "xlsx-shim-js",
                    "https://cdn.sheetjs.com/xlsx-latest/package/dist/shim.min.js",
                );
                await S25Util.loadScript(
                    "xlsx-full-js",
                    "https://cdn.sheetjs.com/xlsx-latest/package/dist/xlsx.full.min.js",
                );
                await S25Util.loadScript(
                    "xlsx-xlsxspread-js",
                    "https://cdn.sheetjs.com/xspreadsheet/xlsxspread.min.js",
                );
                return;
            });
        return SpreadSheetService.scriptsPromise;
    }

    public static async XLSX(): Promise<XLSX> {
        await SpreadSheetService.load();
        return window.XLSX;
    }

    public static async stox(workbook: WorkBook): Promise<Stox> {
        await SpreadSheetService.load();
        return window.stox(workbook);
    }

    public static async toSpreadsheet(sheetData: SheetEntry[], sheetName: string = "Sheet1") {
        return this.toSpreadsheets([{ name: sheetName, data: sheetData }]);
    }

    public static async toSpreadsheets(sheets: Sheet[]) {
        const xlsx = await SpreadSheetService.XLSX();
        const worksheets = sheets.map((sheet) => ({
            name: sheet.name,
            data: xlsx.utils.json_to_sheet(sheet.data),
        }));
        const workbook = xlsx.utils.book_new();
        for (const sheet of worksheets) {
            xlsx.utils.book_append_sheet(workbook, sheet.data, sheet.name);
        }
        return workbook;
    }

    public static async downloadExcel(sheetData: SheetEntry[], filename: string, sheetName: string = "Sheet1") {
        const wb = await SpreadSheetService.toSpreadsheet(sheetData, sheetName);
        let xlsx = await SpreadSheetService.XLSX();
        xlsx.writeFile(wb, filename);
    }

    public static async downloadExcelMulti(sheets: Sheet[], filename: string) {
        const wb = await SpreadSheetService.toSpreadsheets(sheets);
        let xlsx = await SpreadSheetService.XLSX();
        xlsx.writeFile(wb, filename);
    }

    public static async readExcelFile<T>(file: Blob): Promise<T> {
        await SpreadSheetService.load();
        const reader = new FileReader();

        const { promise, resolve } = S25Util.createPromise<T>();

        reader.onload = function (event) {
            const data = event.target.result;
            const workbook = window.XLSX.read(data, { type: "binary" });
            const sheets = workbook.SheetNames.map((name: string) => {
                return window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[name]);
            });
            resolve(sheets);
        };

        reader.onerror = () => {
            alert("Something went wrong");
        };

        reader.readAsArrayBuffer(file);

        return promise;
    }
}

export type Sheet = {
    name: string;
    data: SheetEntry[];
};
